import { Flex } from "antd";
import { FC, useCallback, useContext, useEffect } from "react";
import { useFormContext } from "react-hook-form";

import { CardAddTopic, KMdTextSecondary88, KTopicCardItem } from "@components";
import { KContext } from "@context";
import { updateTopicOfCardTypeService } from "@services";
import { getInfoCard } from "@utils/cardTypeIcon";
import { WrapperCardDetail } from "./share-component";

interface IProps {
  isEditable?: boolean;
  addable: boolean;
}

export const TopicTab: FC<IProps> = ({
  isEditable = false,
  addable = false,
}) => {
  const { topics, fetchTopics, cardTypeSelected, profileId } =
    useContext(KContext);
  const { setValue, getValues, watch } = useFormContext();

  useEffect(() => {
    fetchTopics();
  }, []);

  const onChange = (checked: boolean, id: string) => {
    const topics = getValues("topics") ?? [];

    if (!Array.isArray(topics)) return;
    const newTopics = checked
      ? [...topics, id]
      : topics.filter((i) => i !== id);
    setValue("topics", newTopics, { shouldDirty: true });
  };

  const handleAfterCreate = useCallback(
    async (topicId: string) => {
      const cardId = watch("_id");
      const topics = watch("topics") || [];
      const cardName = getInfoCard(watch("cardType")).path;

      const newTopics = [...topics, topicId];
      if (!cardId || !cardName) {
        return;
      }

      try {
        await updateTopicOfCardTypeService(
          profileId,
          cardName,
          cardId,
          newTopics
        );
        setValue("topics", newTopics, { shouldDirty: false });
      } catch (_) {}
    },
    [profileId, setValue, watch]
  );

  return (
    <WrapperCardDetail>
      {addable && (
        <>
          <KMdTextSecondary88>
            Organize this info by adding it topics.
          </KMdTextSecondary88>

          <CardAddTopic handleAfterCreate={handleAfterCreate} />
        </>
      )}

      {topics.length ? (
        <Flex vertical gap={8}>
          {(topics ?? []).map((i) => (
            <KTopicCardItem
              key={i._id}
              topic={i}
              disabled={!isEditable}
                checked={(watch('topics') ?? []).includes(i._id)}
              onChange={(checked: boolean) => onChange(checked, i._id)}
            />
          ))}
        </Flex>
      ) : null}
    </WrapperCardDetail>
  );
};
